/* BubbleClaus theme scripts: menu, search, cart drawer, gallery, variants, FAQ */
(function () {
  'use strict';

  var T = window.theme || {};
  var R = T.routes || {};
  var S = T.strings || {};

  function qs(selector, ctx) { return (ctx || document).querySelector(selector); }
  function qsa(selector, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(selector)); }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Money ------------------------------------------------------ */
  function formatMoney(cents, format) {
    var formatString = format || T.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    if (typeof cents === 'string') cents = cents.replace('.', '');

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' '); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholder, value);
  }

  /* ---------- Overlays (menu / search / cart) ----------------------------- */
  var lastOpener = null;

  function openOverlay(el, opener) {
    if (!el) return;
    lastOpener = opener || document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var panel = qs('[role="dialog"]', el);
    if (panel) {
      var focusTarget = qs('input[type="search"]', panel) || panel;
      window.setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 30);
    }
    qsa('[aria-controls="' + el.id + '"]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
  }

  function closeOverlay(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    qsa('[aria-controls="' + el.id + '"]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
    if (!qs('.menu-drawer.is-open, .search-modal.is-open, .cart-drawer.is-open')) {
      document.body.classList.remove('is-locked');
    }
    if (lastOpener && lastOpener.focus) lastOpener.focus({ preventScroll: true });
  }

  /* ---------- Cart --------------------------------------------------------- */
  var drawer = null;

  function jsonFetch(url, options) {
    options = options || {};
    options.headers = Object.assign({ 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, options.headers || {});
    return fetch(url, options).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
    });
  }

  function updateCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function showCartError(message) {
    var box = qs('[data-cart-error]');
    if (!box) return;
    if (message) { box.textContent = message; box.hidden = false; } else { box.hidden = true; box.textContent = ''; }
  }

  function imageUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  /* ---------- Cart countdown (optional, cosmetic) ------------------------- */
  var TIMER_KEY = 'bc_cart_timer_end';
  var timerHandle = null;

  function readTimerEnd() {
    try { return parseInt(window.sessionStorage.getItem(TIMER_KEY), 10) || 0; } catch (e) { return 0; }
  }
  function writeTimerEnd(value) {
    try {
      if (value) window.sessionStorage.setItem(TIMER_KEY, String(value)); else window.sessionStorage.removeItem(TIMER_KEY);
    } catch (e) { /* storage unavailable */ }
  }
  function stopTimer() {
    if (timerHandle) { window.clearInterval(timerHandle); timerHandle = null; }
  }

  function syncTimer(cart) {
    var cfg = T.cartTimer;
    var bar = qs('[data-cart-timer]');
    if (!cfg || !cfg.enabled || !bar) return;

    if (!cart.item_count) { writeTimerEnd(0); stopTimer(); bar.hidden = true; return; }

    var end = readTimerEnd();
    if (!end) { end = Date.now() + (cfg.minutes || 5) * 60000; writeTimerEnd(end); }

    function tick() {
      var remaining = Math.round((end - Date.now()) / 1000);
      if (remaining <= 0) {
        // Restart the countdown when it runs out
        end = Date.now() + (cfg.minutes || 5) * 60000;
        writeTimerEnd(end);
        remaining = Math.round((end - Date.now()) / 1000);
      }
      var mm = ('0' + Math.floor(remaining / 60)).slice(-2);
      var ss = ('0' + (remaining % 60)).slice(-2);
      bar.textContent = String(cfg.text || '').replace('{time}', mm + ':' + ss);
      bar.hidden = false;
    }

    stopTimer();
    tick();
    if (!bar.hidden) timerHandle = window.setInterval(tick, 1000);
  }

  /* ---------- Cart rendering ------------------------------------------------ */
  /* Compare-at prices: cart.js doesn't include them, so we read them from the product data.
     Savings are worked out against the compare-at price, like the previous store's cart. */
  var compareAt = {};       // variant id -> compare-at price in cents
  var productLoaded = {};   // product handle -> already requested
  var latestCart = null;

  function fetchCompareAt(cart) {
    var base = String(R.root || '/').replace(/\/$/, '');
    var pending = [];
    cart.items.forEach(function (item) {
      if (!item.handle || productLoaded[item.handle]) return;
      productLoaded[item.handle] = true;
      pending.push(
        fetch(base + '/products/' + encodeURIComponent(item.handle) + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (product) {
            if (!product || !product.variants) return;
            product.variants.forEach(function (v) { compareAt[v.id] = v.compare_at_price || 0; });
          })
          .catch(function () { /* hidden product: fall back to the cart price */ })
      );
    });
    return Promise.all(pending).then(function () { return pending.length > 0; });
  }

  function renderCart(cart) {
    latestCart = cart;
    paintCart(cart);
    if (cart.item_count) {
      fetchCompareAt(cart).then(function (loaded) {
        if (loaded && latestCart === cart) paintCart(cart);
      });
    }
  }

  function paintCart(cart) {
    drawer = drawer || qs('[data-cart-drawer]');
    if (!drawer) return;
    var body = qs('[data-cart-body]', drawer);
    var footer = qs('[data-cart-footer]', drawer);
    var summaryEl = qs('[data-cart-summary]', drawer);
    var title = qs('[data-cart-title]', drawer);
    updateCount(cart.item_count);
    if (title) title.textContent = S.cart + ' \u2022 ' + cart.item_count + ' ' + (cart.item_count === 1 ? S.item : S.items);
    syncTimer(cart);

    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty"><p>' + esc(S.emptyCart) + '</p>' +
        '<a class="btn btn--primary" href="' + esc(R.allProducts || R.root || '/') + '">' + esc(S.continueShopping) + '</a></div>';
      footer.hidden = true;
      summaryEl.innerHTML = '';
      return;
    }

    var html = '<ul class="cart-lines" role="list">';
    var compareExtra = 0;

    cart.items.forEach(function (item, index) {
      var line = index + 1;
      var unitCompare = Math.max(compareAt[item.variant_id] || 0, item.original_price);
      var linePrice = unitCompare * item.quantity;
      var saved = Math.max(0, linePrice - item.final_line_price);
      compareExtra += Math.max(0, unitCompare - item.original_price) * item.quantity;
      var meta = '';

      if (T.showVariant !== false && item.variant_title && !item.product_has_only_default_variant) {
        meta += '<p class="cart-line__meta">' + esc(item.variant_title) + '</p>';
      }
      if (item.properties && typeof item.properties === 'object') {
        Object.keys(item.properties).forEach(function (key) {
          var val = item.properties[key];
          if (key.charAt(0) === '_' || val === '' || val == null || typeof val === 'object') return;
          meta += '<p class="cart-line__meta">' + esc(key) + ': ' + esc(val) + '</p>';
        });
      }

      var tags = [];
      (item.line_level_discount_allocations || []).forEach(function (alloc) {
        var t = alloc.discount_application && alloc.discount_application.title;
        if (t && tags.indexOf(t) === -1) tags.push(t);
      });
      var unit = '';
      if (tags.length) {
        unit = '<div class="cart-line__unit">' +
          tags.map(function (t) {
            return '<span class="cart-line__tag"><svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.6 11.4l-8-8A2 2 0 0 0 11.2 3H4a1 1 0 0 0-1 1v7.2c0 .5.2 1 .6 1.4l8 8a2 2 0 0 0 2.8 0l6.2-6.2a2 2 0 0 0 0-2.8zM7.5 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/></svg>' + esc(t) + '</span>';
          }).join('') +
        '</div>';
      }

      html += '<li class="cart-line" data-line="' + line + '">' +
        '<a class="cart-line__image" href="' + esc(item.url) + '">' +
          (item.image ? '<img src="' + esc(imageUrl(item.image, 200)) + '" alt="' + esc(item.featured_image && item.featured_image.alt || item.product_title) + '" width="74" height="74" loading="lazy">' : '') +
        '</a>' +
        '<div class="cart-line__info">' +
          '<div class="cart-line__top">' +
            '<a class="cart-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
            '<button type="button" class="cart-line__remove" data-remove aria-label="' + esc(S.remove) + ' ' + esc(item.product_title) + '">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>' +
            '</button>' +
          '</div>' +
          unit +
          meta +
          '<div class="cart-line__bottom">' +
            '<div class="qty">' +
              '<button type="button" class="qty__btn" data-qty-minus aria-label="Decrease quantity"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg></button>' +
              '<input class="qty__input" type="number" min="0" inputmode="numeric" value="' + item.quantity + '" aria-label="Quantity for ' + esc(item.product_title) + '" data-qty-input>' +
              '<button type="button" class="qty__btn" data-qty-plus aria-label="Increase quantity"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button>' +
            '</div>' +
            '<div class="cart-line__price">' +
              '<div class="cart-line__price-row">' +
                (saved > 0 ? '<s class="price__compare">' + esc(formatMoney(linePrice)) + '</s>' : '') +
                '<span' + (saved > 0 ? ' class="price__sale"' : '') + '>' + esc(formatMoney(item.final_line_price)) + '</span>' +
              '</div>' +
              (saved > 0 ? '<div class="cart-line__save">(You save ' + esc(formatMoney(saved)) + ')</div>' : '') +
            '</div>' +
          '</div>' +
        '</div>' +
      '</li>';
    });
    html += '</ul>';
    body.innerHTML = html;

    var savingsTotal = compareExtra + (cart.total_discount || 0);
    var summary = '<div class="cart-summary">';
    if (savingsTotal > 0) {
      summary += '<div class="cart-summary__row cart-summary__row--savings"><span>' + esc(S.savings) + '</span><span>-' + esc(formatMoney(savingsTotal)) + '</span></div>';
    }
    summary += '<div class="cart-summary__row cart-summary__row--total"><span>' + esc(S.subtotal) + '</span><span>' + esc(formatMoney(cart.total_price)) + '</span></div>' +
      '<form action="' + esc(R.cart || '/cart') + '" method="post" class="cart-summary__form"><button type="submit" name="checkout" class="btn btn--primary btn--full btn--checkout">' + esc(S.checkout) + '</button></form>' +
      '</div>';
    summaryEl.innerHTML = summary;
    footer.hidden = false;
  }

  function refreshCart() {
    return jsonFetch(R.cartJs || '/cart.js').then(function (res) {
      if (res.ok) renderCart(res.data);
      return res.data;
    }).catch(function () { showCartError(S.errorGeneric); });
  }

  function openCart(opener) {
    drawer = drawer || qs('[data-cart-drawer]');
    if (!drawer) return;
    showCartError('');
    openOverlay(drawer, opener);
    refreshCart();
  }

  function changeLine(line, quantity) {
    drawer = drawer || qs('[data-cart-drawer]');
    showCartError('');
    drawer.classList.add('is-updating');
    return jsonFetch(R.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (res) {
      if (!res.ok) {
        showCartError(res.data && (res.data.message || res.data.description) || S.errorGeneric);
        return refreshCart();
      }
      var item = res.data.items[line - 1];
      if (quantity > 0 && item && item.quantity !== quantity) showCartError(S.errorQuantity);
      renderCart(res.data);
    }).catch(function () {
      showCartError(S.errorGeneric);
    }).then(function () {
      drawer.classList.remove('is-updating');
    });
  }

  function handleAddToCart(form) {
    var button = qs('[data-add-to-cart]', form);
    var errorBox = qs('[data-form-error]', form);
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
    if (button) button.classList.add('is-loading');

    return jsonFetch(R.cartAdd || '/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          throw new Error(res.data && (res.data.description || res.data.message) || S.errorGeneric);
        }
        return jsonFetch(R.cartJs || '/cart.js');
      })
      .then(function (res) {
        renderCart(res.data);
        openOverlay(drawer || qs('[data-cart-drawer]'), button);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: res.data } }));
      })
      .catch(function (err) {
        if (errorBox) { errorBox.textContent = err.message || S.errorGeneric; errorBox.hidden = false; }
      })
      .then(function () {
        if (button) button.classList.remove('is-loading');
      });
  }

  // Public hooks other scripts and apps can call
  window.theme = window.theme || {};
  window.theme.cart = { open: openCart, refresh: refreshCart, render: renderCart };
  document.addEventListener('cart:refresh', function () { refreshCart(); });

  /* ---------- Gallery ------------------------------------------------------ */
  function initGallery(root) {
    if (root.dataset.galleryReady) return;
    root.dataset.galleryReady = '1';

    var track = qs('[data-gallery-track]', root);
    if (!track) return;
    var slides = qsa('.gallery__slide', track);
    var thumbs = qsa('[data-thumb]', root);
    var prev = qs('[data-gallery-prev]', root);
    var next = qs('[data-gallery-next]', root);
    var ticking = false;

    function setActive(i) {
      thumbs.forEach(function (t, idx) {
        if (idx === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (thumbs[i] && thumbs[i].parentNode && thumbs[i].parentNode.parentNode) {
        var strip = thumbs[i].parentNode.parentNode;
        if (strip.scrollWidth > strip.clientWidth) {
          strip.scrollTo({ left: thumbs[i].offsetLeft - 12, behavior: 'smooth' });
        }
      }
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }

    function currentIndex() {
      var x = track.scrollLeft, best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - x);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) best = slides.length - 1;
      return best;
    }

    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; setActive(currentIndex()); });
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(currentIndex() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(currentIndex() - 1); }
    });

    if (prev) prev.addEventListener('click', function () { go(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { go(currentIndex() + 1); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });

    root.galleryGoToMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { go(i); return; }
      }
    };
    setActive(0);
  }

  /* ---------- Product: variants -------------------------------------------- */
  function initProduct(section) {
    if (section.dataset.productReady) return;
    section.dataset.productReady = '1';

    var jsonEl = qs('[data-variants-json]', section);
    var picker = qs('[data-variant-picker]', section);
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    variants.forEach(function (v) { compareAt[v.id] = v.compare_at_price || 0; });
    var handleMatch = (section.getAttribute('data-product-url') || '').match(/\/products\/([^/?#]+)/);
    if (handleMatch) productLoaded[decodeURIComponent(handleMatch[1])] = true;

    if (!picker) return;

    var idInput = qs('[data-variant-id]', section);
    var button = qs('[data-add-to-cart]', section);
    var buttonText = qs('[data-add-to-cart-text]', section);
    var priceEl = qs('[data-price]', section);
    var gallery = qs('[data-gallery]', section);
    var updateUrl = section.getAttribute('data-update-url') === 'true';

    function findVariant() {
      var chosen = qsa('[data-option-fieldset]', picker).map(function (fs) {
        var checked = qs('input:checked', fs);
        return checked ? checked.value : null;
      });
      return variants.filter(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      })[0];
    }

    function renderPrice(v) {
      if (!priceEl) return;
      if (v.compare_at_price && v.compare_at_price > v.price) {
        priceEl.innerHTML = '<span class="price__sale">' + esc(formatMoney(v.price)) + '</span> <s class="price__compare">' + esc(formatMoney(v.compare_at_price)) + '</s>';
      } else {
        priceEl.innerHTML = '<span class="price__regular">' + esc(formatMoney(v.price)) + '</span>';
      }
    }

    picker.addEventListener('change', function () {
      var v = findVariant();
      var label = button ? button.getAttribute('data-label') : '';
      if (!v) {
        if (button) button.disabled = true;
        if (buttonText) buttonText.textContent = S.unavailable || 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      renderPrice(v);
      if (button) button.disabled = !v.available;
      if (buttonText) buttonText.textContent = v.available ? label : (S.soldOut || 'Sold out');
      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (gallery && gallery.galleryGoToMedia && v.featured_media) gallery.galleryGoToMedia(v.featured_media.id);
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v, section: section } }));
    });
  }

  /* ---------- FAQ ----------------------------------------------------------- */
  function toggleFaq(btn) {
    var list = btn.closest('[data-faq]');
    var answer = document.getElementById(btn.getAttribute('aria-controls'));
    var open = btn.getAttribute('aria-expanded') === 'true';
    qsa('[data-faq-toggle]', list).forEach(function (other) {
      other.setAttribute('aria-expanded', 'false');
      var a = document.getElementById(other.getAttribute('aria-controls'));
      if (a) a.hidden = true;
    });
    if (!open && answer) {
      btn.setAttribute('aria-expanded', 'true');
      answer.hidden = false;
    }
  }

  /* ---------- Global events -------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var menuOpen = t.closest('[data-menu-open]');
    if (menuOpen) { e.preventDefault(); openOverlay(qs('[data-menu-drawer]'), menuOpen); return; }
    if (t.closest('[data-menu-close]')) { closeOverlay(qs('[data-menu-drawer]')); return; }

    var searchOpen = t.closest('[data-search-open]');
    if (searchOpen) { e.preventDefault(); openOverlay(qs('[data-search-modal]'), searchOpen); return; }
    if (t.closest('[data-search-close]')) { closeOverlay(qs('[data-search-modal]')); return; }

    var cartOpen = t.closest('[data-cart-open]');
    if (cartOpen && T.cartDrawer && qs('[data-cart-drawer]')) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      openCart(cartOpen);
      return;
    }
    if (t.closest('[data-cart-close]')) { closeOverlay(qs('[data-cart-drawer]')); return; }

    var faqBtn = t.closest('[data-faq-toggle]');
    if (faqBtn) { toggleFaq(faqBtn); return; }

    var line = t.closest('.cart-line[data-line]');
    if (line && line.closest('[data-cart-drawer]')) {
      var lineNo = parseInt(line.getAttribute('data-line'), 10);
      var input = qs('[data-qty-input]', line);
      var qty = parseInt(input.value, 10) || 0;
      if (t.closest('[data-qty-minus]')) { changeLine(lineNo, Math.max(0, qty - 1)); return; }
      if (t.closest('[data-qty-plus]')) { changeLine(lineNo, qty + 1); return; }
      if (t.closest('[data-remove]')) { changeLine(lineNo, 0); return; }
    }

    if (t.closest('[data-back-to-top]')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) {
      var line = input.closest('.cart-line[data-line]');
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      changeLine(parseInt(line.getAttribute('data-line'), 10), qty);
      return;
    }
    var pageQty = e.target.closest('[data-cart-page-qty]');
    if (pageQty && pageQty.form) pageQty.form.submit();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || e.defaultPrevented) return;
    if (!T.cartDrawer || !qs('[data-cart-drawer]')) return; // fall back to normal form post
    var button = qs('[data-add-to-cart]', form);
    if (button && (button.disabled || button.classList.contains('is-loading'))) { e.preventDefault(); return; }
    e.preventDefault();
    handleAddToCart(form);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    ['[data-cart-drawer]', '[data-menu-drawer]', '[data-search-modal]'].forEach(function (sel) { closeOverlay(qs(sel)); });
  });

  /* Back to top visibility */
  var backToTop = qs('[data-back-to-top]');
  if (backToTop) {
    var topTicking = false;
    var onScroll = function () {
      if (topTicking) return;
      topTicking = true;
      window.requestAnimationFrame(function () {
        topTicking = false;
        backToTop.hidden = window.scrollY < 400;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Init + theme editor support ------------------------------------ */
  function initAll(ctx) {
    qsa('[data-gallery]', ctx).forEach(initGallery);
    qsa('[data-product-section]', ctx).forEach(initProduct);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initAll(document);
    drawer = qs('[data-cart-drawer]');
    if (T.cartDrawer && drawer) {
      jsonFetch(R.cartJs || '/cart.js').then(function (res) { if (res.ok) renderCart(res.data); });
    }
  });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
